// extracted by mini-css-extract-plugin
module.exports = {"content-sidebar-bookmarks":"ContentSidebarBookmarks_content-sidebar-bookmarks__0__24","is-active":"ContentSidebarBookmarks_is-active__X_Vrr"};